//import 'ol/ol.css';
import { Feature } from 'ol';
import * as toastr from "toastr";
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult} from '../Models/UtilityModels';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { MapLayerGroupType, MapConfigModel, INewGeometryConfig } from '../Models/MapConfigModels';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_InfraCondition, infraConditionCallback } from './Entity_InfraCondition'
import { Entity_InfraHistoric } from './Entity_InfraHistoric';
import { Entity_InfraView } from './Entity_InfraView';

declare let moment: any; // Date helper from moment()

// LUT table 
export class InfraTypeModel { infraType: string; groupName: string; descr: string; }

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Infra {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private Entity_InfraCondition: Entity_InfraCondition = new Entity_InfraCondition();
    private Entity_InfraHistoric: Entity_InfraHistoric = new Entity_InfraHistoric();
    private Entity_InfraView: Entity_InfraView;
    private eventNewMapGeometryCompleted;
    private authModel: AuthModel.IAuthModel = { policies: [] };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, authModel: AuthModel.IAuthModel, protected mapConfigModel: MapConfigModel) {
        this.authModel = authModel;
        this.Entity_InfraView = new Entity_InfraView(map, authModel, mapConfigModel);
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey, callback: Function): void => {
        this.Entity_InfraView.openEditPanel(data, callback);
    }

    public openCreatePanel = (data: ICAMSKey, callback: Function): void => {
        this.Entity_InfraView.openCreatePanel(data, callback);
    }

    // ----------------------------------------------------------- //
    // CONDITION
    public openConditionPanel = (data: ICAMSKey, infraConditionCode: string, callback: infraConditionCallback): void => {
        this.Entity_InfraCondition.openConditionPanel(data, infraConditionCode, callback);
    }

    // ----------------------------------------------------------- //
    // HISTORIC
    public openInfraHistoricPanel = (camsKey: ICAMSKey, callback: Function): void => {
        this.Entity_InfraHistoric.openHistoricPanel(camsKey, callback);
    }

    // ----------------------------------------------------------- //
    // New Infra WIZARD
    public newInfraWizard_Start = (data: ICAMSKey, featureSelected: Feature, callback: Function): void => {
        const self = this;

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Infra, true]));

        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                self.openCreatePanel(e.payload[1], callback);
            }
        });

        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route, FeatureType.Land] };
        let config: INewGeometryConfig = { data: data, featureType: FeatureType.Infra, featureSelected: featureSelected, interactionData: interactionData, createEntityMaxDistanceAway: self.mapConfigModel.createEntityMaxDistanceAway };
        events.bus.publish(events.eventNewMapGeometryStart([config, callback]));
    }

    // ----------------------------------------------------------- //
    // GET FEATURE
    public getFeatureAndZoomToLocation = (data: ICAMSKey): void => {
        $.post('/Infra/GetInfra', { code: data.code },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (result.data.WKT != null) {
                            events.bus.publish(events.eventZoomToWKTandHighlight([[result.data.WKT], true, true, FeatureType.Infra]));
                        }
                        else {
                            toastr.error('Failed to get furniture geometry!');
                        }
                    }
                    else {
                        toastr.error('Failed to get furniture item!');
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey, callback: Function): void => {
        this.Entity_InfraView.deleteEntity(data, callback);
    }


    // ----------------------------------------------------------- //
    // MISC
    
}